export const projectTwo = {
  id: 'Project',
  lightBg: false,
  lightText: true,
  lightTextDesc: true,
  topLine: 'Project 2',
  headline: 'EESANA',
  description:
    "Helped develop and deploy website for Eritrean Ethiopian Student Association (EESANA). EESANA was established in March 2020 by students to bridge the gap between different Eritrean Ethiopian Student Associations across college campuses and their respective countries.",
  buttonLabel: 'React Native',
  buttonLabel2: "Website",
  imgStart: false,
  img: require('../../images/eesana.png'),
  alt: 'EESANA',
  dark: true,
  primary: true,
  darkText: false
};
